export default __webpack_public_path__ + "c5e7f03f1461264040a3ca78840c7ae2.png";